module.exports = __webpack_public_path__ + "static/media/snow.64cba331.gif";